import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/about/components/AboutContent.tsx");
